module.exports = __webpack_public_path__ + "img/kg.fa6b8f64.png";